module.exports = __webpack_public_path__ + "static/media/ch.d2f1ce5e.svg";